import { http } from "../client";
import axios from "axios";
export var ActivateDeviceFailureVariant;
(function (ActivateDeviceFailureVariant) {
    ActivateDeviceFailureVariant[ActivateDeviceFailureVariant["BadRequest"] = 0] = "BadRequest";
    ActivateDeviceFailureVariant[ActivateDeviceFailureVariant["Forbidden"] = 1] = "Forbidden";
    ActivateDeviceFailureVariant[ActivateDeviceFailureVariant["NotFound"] = 2] = "NotFound";
})(ActivateDeviceFailureVariant || (ActivateDeviceFailureVariant = {}));
var mapErrorToFailureVariant = function (error) {
    var _a;
    if (axios.isAxiosError(error)) {
        var status_1 = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
        if (status_1 === 400)
            return ActivateDeviceFailureVariant.BadRequest;
        if (status_1 === 403)
            return ActivateDeviceFailureVariant.Forbidden;
        if (status_1 === 404)
            return ActivateDeviceFailureVariant.NotFound;
    }
    return null;
};
export var activateDevice = function (key) {
    return http.api
        .post("devices/activate", {
        activation_key: key,
    })
        .then(function (response) { return response.data; })
        .then(function (data) { return ({ id: data.device_id }); })
        .catch(function (error) { return Promise.reject(mapErrorToFailureVariant(error)); });
};
